import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'getRemarkHeader',
})
export class GetRemarkHeaderPipe implements PipeTransform {
	transform(i: number): 'הערה ראשית' | `הערה ${number}` {
		return i === 0 ? 'הערה ראשית' : `הערה ${i}`;
	}
}
